import 'jquery-ui-bundle';
import 'uikit';
import 'jstree';
import { async } from 'q';
import { axiosGetSeoData } from '../api/admin/default';

$(function ($) {
    var currentPageData =
        parent.currentPageJSON != undefined ? parent.currentPageJSON : '';
    var currentTab = 'site';
    var currentId = {};
    var defaultId;
    var defaultObj;
    var activeData;
    var activeAuto = true;
    var moduleActive = '';
    var packagename = '';
    var dataCustomSeo = {};

    $(document).ready(function () {
        parent
            .$('.panel-showhide')
            .unbind('click')
            .click(function () {
                $(this).closest('.ui-draggable').hide();
                $('.overlaypanel').remove();
                parent.$('.overlaypanel').remove();
                $('.bodyscrollhide').removeClass('bodyscrollhide');
                parent.$('.bodyscrollhide').removeClass('bodyscrollhide');
            });

        BuildSiteConfigTabs();
        dataLists();
        EventVisibility();

        $('#page-homesetting').click(function () {
            elementPageBase();
        });

        $('#post-homesetting').click(function () {
            elementPostBase();
        });

        //form changed
        var objform = $(
            '#siteproperty, #pageproperty, #postproperty, #systemproperty'
        );
        objform
            .bind('form :input, select, textarea')
            .on('keyup change paste', function () {
                showSavebtn();
            });

        //contenteditable changed
        objform
            .on('focus', '[contenteditable]', function () {
                const $this = $(this);
                $this.data('before', $this.html());
            })
            .on('blur keyup paste input', '[contenteditable]', function (e) {
                const $this = $(this);
                if ($this.data('before') !== $this.html()) {
                    showSavebtn();
                }
                if (e.type == 'paste') {
                    setTimeout(function () {
                        $this.text(striptags($this.text()));
                        $this.trigger('keydown');
                    }, 0);
                }
            });

        $(
            '#saveSiteProperty ,#savePageProperty ,#savePostProperty ,#saveSystemProperty'
        ).click(function () {
            var obj = $('#' + currentTab + 'property');

            var seoType;
            var data = obj.serialize();

            var checkTags = window.validationTags(obj);
            if (checkTags == false) {
                return;
            }

            //	          saveproperty
            if (
                (typeof activeData != 'undefined' && activeData != null) ||
                currentTab == 'site'
            ) {
                obj.find('#auto-seo').hasClass('uk-active')
                    ? (seoType = 1) /** Auto **/
                    : (seoType = 0) /** Custom **/;
                var arrrole = [];
                $.each(obj.find('.role:checked'), function () {
                    arrrole.push($(this).val());
                });

                var slugpage =
                    activeData == undefined
                        ? slugIdConfig.slug_id
                        : activeData.slug_id;

                data = `${data}
                &slug_id=${slugpage}
                &slug_name=${obj.find('#previewUrlSEO').val()}
                &seoType=${seoType}
                &metaTitle=${obj.find('#previewTitleSEO').text()}
                &metaDes=${obj.find('#previewDesSEO').text()}
                &visibility=${obj.find('.visibility:checked').val()}
                &role=${arrrole}`;

                var classRefresh = '.mode-seo';
                var refreshAfterSave = $(`${classRefresh}`).hasClass(
                    'ui-tabs-active'
                );
                console.log('activeData: ', activeData);
                var slugURL =
                    activeData?.slug_name != obj.find('#previewUrlSEO').val();
                console.log('slugURL: ', slugURL);

                if (refreshAfterSave && slugURL) {
                    modalRefreshAfterSave(data);
                } else {
                    saveSiteProperty(data);
                }
            }

            var Permalink = $(`.post-base`).hasClass('ui-tabs-active');
            if (currentTab == 'post' && Permalink) {
                savePostProperty(obj);
            }
        });

        // favicon
        $('.section-logo').css({
            background: `url(${
                parent.wex.url.baseUrl
            }/storage/images/favicon.ico?${new Date().getTime()})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '16px 16px',
        });

        function faviconUpload(data) {
            $.ajax({
                type: 'POST',
                url: parent.wex.url.baseUrl + '/admin/siteproperty/favicon',
                data: data,
                processData: false,
                contentType: false,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr(
                        'content'
                    ),
                },
                success: function (res) {
                    $('.section-logo').css({
                        background: `url(${
                            parent.wex.url.baseUrl
                        }/storage/images/favicon.ico?${new Date().getTime()})`,
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '16px 16px',
                    });

                    disabledSavebtn();

                    var strcurrentTab = [currentTab].toString();
                    var msgCurrent =
                        strcurrentTab.charAt(0).toUpperCase() +
                        strcurrentTab.slice(1);

                    parent.console.pop.success({
                        title: 'Success',
                        text: msgCurrent + ' config saved.',
                        delay: 2000,
                    });
                },
                error: function (xhr, thrownError) {
                    disabledSavebtn();
                    let msg = '';
                    if (typeof xhr.responseJSON.errors !== typeof undefined)
                        msg = xhr.responseJSON.errors.file;
                    else msg = xhr.responseJSON.message;

                    parent.console.pop.error({
                        title: 'Error',
                        text: msg,
                    });
                },
            });
        }

        function faviconRead(input) {
            const file = new FormData();
            const reader = new FileReader();

            file.append('file', input[0]);
            let prop = {
                fileName: input[0].name.split('.').slice(0, -1).join('.'),
                HeightWidth: '',
                size: '',
                type: '',
            };

            if (input[0].size < 1000000) {
                const _size = Math.floor(input[0].size / 1000) + 'KB';
                prop = { ...prop, size: _size };
            } else {
                const _size = Math.floor(input[0].size / 1000000) + 'MB';
                prop = { ...prop, size: _size };
            }

            reader.onload = function (e) {
                const faviconImg = new Image();
                faviconImg.src = e.target.result;

                faviconImg.onload = function () {
                    prop = {
                        ...prop,
                        HeightWidth: `${this.width}x${this.height}`,
                    };
                    prop = {
                        ...prop,
                        type: faviconImg.src
                            .replace(/^data\:image\//gim, '')
                            .replace(/\;base64(.*)/gim, ''),
                    };

                    file.append('fileName', prop.fileName);
                    file.append('HeightWidth', prop.HeightWidth);
                    file.append('size', prop.size);
                    file.append('type', prop.type);

                    faviconUpload(file);
                };
            };
            reader.readAsDataURL(input[0]);
        }

        $('.event-brand').change(function (e) {
            disabledSavebtn();

            faviconRead(e.target.files);
        });

        $('#previewTitleSEO').keydown(function () {
            warningMaximun($('#warningMaximunTitleSEO'), 255);
        });

        $('#previewDesSEO').keydown(function () {
            warningMaximun($('#warningMaximunDescriptionSEO'), 155);
        });

        $('#savemoduleProperty').click(function () {
            var data = {};
            data['packagename'] = packagename;

            $('.' + moduleActive).each(function (key, isElem) {
                var idElem = $(isElem).attr('href');

                $(`${idElem}`)
                    .find(':input')
                    .each(function (index, element) {
                        switch (element.type) {
                            case 'radio':
                                if (element.checked) {
                                    dataKey = element.getAttribute('name');
                                    dataVal = element.value;
                                }

                                break;
                            default:
                                var dataKey = element.getAttribute('name');
                                var dataVal = element.value;
                                break;
                        }

                        data[dataKey] = dataVal;
                    });
            });

            $.ajax({
                type: 'POST',
                url: parent.wex.url.baseUrl + '/admin/validation',
                data: data,
                // dataType: "dataType",
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr(
                        'content'
                    ),
                },
                success: function (responseText) {
                    console.log(data);
                    //
                    switch (data['packagename']) {
                        case 'rvsitebuilder/core':
                            activeToPanel(data);
                            break;
                        default:
                            //rvsitebuilder/manage
                            //rvsitebuilder/developer
                            //rvsitebuilder/larecipe
                            break;
                    }

                    var strcurrentTab = [currentTab].toString();
                    var msgCurrent =
                        strcurrentTab.charAt(0).toUpperCase() +
                        strcurrentTab.slice(1);

                    parent.console.pop.success({
                        title: 'Success',
                        text: msgCurrent + ' config saved.',
                        delay: 2000,
                    });
                },
                error: function (xhr) {
                    console.log(xhr.responseJSON.message);
                    console.log('sss');
                    console.log(xhr);
                    $.each(
                        xhr.responseJSON.errors,
                        function (indexInArray, valueOfElement) {
                            const isindexInArray = indexInArray
                                .replace('_', ' ')
                                .toLowerCase()
                                .replace(/\b[a-z]/g, function (txtVal) {
                                    return txtVal.toUpperCase();
                                });

                            parent.console.pop.error({
                                title: isindexInArray,
                                text: valueOfElement,
                            });
                        }
                    );
                },
            });
        });

        updateDataSEO(
            document.getElementsByClassName('previewDesSEO'),
            'description'
        );
        updateDataSEO(document.getElementsByClassName('previewUrlSEO'), 'url');
        updateDataSEO(
            document.getElementsByClassName('previewTitleSEO'),
            'title'
        );
    });

    function updateDataSEO(elem, customkey) {
        for (let i = 0; i < elem.length; i++) {
            const thisElement = elem[i];
            thisElement.addEventListener('keyup', e => {
                console.log(thisElement.textContent);

                dataCustomSeo[customkey] =
                    thisElement.textContent == ''
                        ? thisElement.value
                        : thisElement.textContent;
            });
        }
    }
    function activeToPanel(data) {
        console.log('parent');
        console.log(parent.$('body').get(0));
        console.log(parent.$('.wgFrame[data-widgetname^=login-]'));
        // case open siteproperty on wysiwyg
        const oPanelLogin = parent.$('.wgFrame[data-widgetname^=login-]');

        if (oPanelLogin.get(0)) {
            const pl = oPanelLogin.get(0).contentWindow;
            const aLogin = {};
            data = JSON.stringify(data).replace(
                /services\.(.*?)\.(client_id|client_secret)\"\:\"(.*?)\"/gim,
                function (m, k, k2, val) {
                    if (!aLogin[k]) aLogin[k] = {};
                    aLogin[k][k2] = val;
                    return m;
                }
            );
            console.log(aLogin);
            $.each(aLogin, function (k, v) {
                let dataActive = 0;
                let mulClass = 'addClass';
                const isChecked = null;
                const ths = pl.$('[cmd="setting_social_' + k + '"]');
                if (v.client_id != '' && v.client_secret != '') {
                    dataActive = 1;
                    mulClass = 'removeClass';
                }
                ths.parent()
                    .parent()
                    [mulClass]('disable-sociallogin')
                    .prev()
                    [mulClass]('disable-sociallogin');

                if (ths.is(':checked') && mulClass == 'addClass') {
                    $.when(ths.attr('data-active', 0).click()).then(
                        function () {
                            pl.$('.savewidget').click();
                        }
                    );
                }

                if (!ths.is(':checked') && mulClass == 'removeClass') {
                    $.when(ths.attr('data-active', 1).click()).then(
                        function () {
                            pl.$('.savewidget').click();
                        }
                    );
                }
            });
            /*
            // ต้องการที่จะแสดงค้างไว้ในหน้า wysiwyg ให้ดูticket https://app.clickup.com/t/2hp0fc
            if (data) parent.$('.wys-pageproperty').hide();
            $('.overlaypanel').remove();
            parent.$('.overlaypanel').remove();
            */
        }
    }
    function striptags(content) {
        var frag = document.createDocumentFragment();
        var innerEl = document.createElement('div');
        frag.appendChild(innerEl);
        innerEl.innerHTML = content;
        return frag.firstChild.innerText;
    }

    window.SetCurrentTab = function (tabActive, slugId, setTab) {
        console.log('function : SetCurrentTab');
        console.log('tabActive: ', tabActive);
        console.log('slugId: ', slugId);
        console.log('setTab: ', setTab);

        $('a[href*=' + tabActive + '-tab]').trigger('click');

        if (slugId != '') {
            setTimeout(function () {
                $(`#${tabActive}-tab li[slug-id="${slugId}"] a:first`).trigger(
                    'click'
                );
            }, 200);

            setTimeout(function () {
                $('#' + tabActive + 'property')
                    .find('.Pageprop')
                    .tabs({
                        active: setTab,
                    });
            }, 200);
        }
    };

    window.SetCurrentConfig = function (tabmain, appname, tabname) {
        var tabmain = tabmain.toLowerCase();
        var appsname = appname.toLowerCase();
        var tabsname = tabname.toLowerCase();
        var idTabsname = tabsname.replace(/\s/, '-');

        console.log('function :: window.SetCurrentConfig');

        $(`a[href*=${tabmain}-tab]`).trigger('click');

        switch (tabmain) {
            case 'page':
            case 'blog':
            case 'system':
                $(`#${tabmain}-tab li[slug-name=${appsname}] a:first`).trigger(
                    'click'
                );
                $(`#${tabmain}-tab a[href*="${tabsname}"]`).trigger('click');
                break;
            case 'site':
                var id = $(`[package="${appsname}"]`).attr('id');
                var elemActive = $(`[package="${appsname}"] a:first`);
                elemActive.trigger('click');

                if (!$(`a[href="#custom-${tabsname}"]`).get(0)) {
                    elemActive = $(`a.${id}#${idTabsname}`).get(0)
                        ? $(`a.${id}#${idTabsname}`)
                        : $(`a.${id}`);
                }

                elemActive.trigger('click');
                break;
            default:
                break;
        }
    };

    window.validationTags = function (obj) {
        var cssData = obj.find('#editorCssCustom');
        var jsData = obj.find('#editorJsCustom');
        if (currentTab == 'site') {
            cssData = obj.find('#editorCssGlobal');
            jsData = obj.find('#editorJsGlobal');
        }
        cssData.keyup(function () {
            obj.find('.err_editorCssCustom').addClass('uk-hidden');
        });
        jsData.keyup(function () {
            obj.find('.err_editorJSCustom').addClass('uk-hidden');
        });

        var begin_Csstag = cssData.val().match(/\<(\s)?style(.*)\>/gim);
        begin_Csstag = begin_Csstag ? begin_Csstag.length : 0;

        var end_Csstag = cssData.val().match(/\<(\s)?\/(\s)?style(\s)?\>/gim);
        end_Csstag = end_Csstag ? end_Csstag.length : 0;

        var RegExpMatchLinkTag = cssData.val().match(/\<(\s)?link(.*)\>/gim);
        RegExpMatchLinkTag = RegExpMatchLinkTag ? RegExpMatchLinkTag.length : 0;

        var full_Csstag = cssData
            .val()
            .match(
                /^<(\s)?style(.*?)\>(.|\s)*?\<(\s)?\/(\s)?style(\s)?\>|\<(\s)?link(.*)\>/gim
            );
        full_Csstag = full_Csstag ? full_Csstag.length : 0;

        var begin_Jstag = jsData.val().match(/\<(\s)?script(.*)\>/gim);
        begin_Jstag = begin_Jstag ? begin_Jstag.length : 0;

        var end_Jstag = jsData.val().match(/\<(\s)?\/(\s)?script(\s)?\>/gim);
        end_Jstag = end_Jstag ? end_Jstag.length : 0;

        var full_Jstag = jsData
            .val()
            .match(
                /\<(\s)?script(.*?)\>(.|\s)*?\<(\s)?\/(\s)?script(\s)?\>/gim
            );
        full_Jstag = full_Jstag ? full_Jstag.length : 0;

        var validateCheck = true;

        if (
            begin_Jstag != full_Jstag ||
            end_Jstag != full_Jstag ||
            (jsData.val() && full_Jstag == 0)
        ) {
            obj.find('.err_editorJSCustom').removeClass('uk-hidden');
            validateCheck = false;
        }

        if (RegExpMatchLinkTag > 0) {
            begin_Csstag += RegExpMatchLinkTag;
            end_Csstag += RegExpMatchLinkTag;
        }

        var CheckTag =
            begin_Csstag != full_Csstag ||
            end_Csstag != full_Csstag ||
            (cssData.val() && full_Csstag == 0);

        if (CheckTag) {
            obj.find('.err_editorCssCustom').removeClass('uk-hidden');
            validateCheck = false;
        }

        return validateCheck;
    };

    function warningMaximun(element, maxinum) {
        if ($(this).text().length > maxinum && event.keyCode != 8) {
            event.preventDefault();
            element.fadeIn();
            if ($(this).text().length > maxinum + 1) {
                $(this).text(
                    $(this)
                        .text()
                        .substring(0, maxinum + 1)
                );
            }
        } else {
            element.fadeOut();
        }
    }

    function savePostProperty(obj) {
        var UI = parent.UIkit;

        var options = {
            bgclose: false,
            keyboard: false,
            modal: false,
        };

        var postBaseUrl = $('#custom-postBaseUrl').prop('checked')
            ? $('#postBaseUrl').val()
            : $('#radiopostBaseUrl').val();
        var categoryBaseUrl = $('#custom-categoryBaseUrl').prop('checked')
            ? $('#categoryBaseUrl').val()
            : $('#radiocategoryBaseUrl').val();

        var slug_id = $('#slug_id').val();

        if (typeof activeData != 'undefined' && activeData != null) {
            slug_id = activeData.slug_id;
        }

        var modalsavePost = UI.modal.dialog(
            [
                '<div class="uk-margin uk-modal-header"><h2>Save & Refresh</h2></div>',
                '<div class="uk-margin uk-modal-content">Do you want to save changes? It will automatically refresh this page.</div>',
                '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">Ok</button>',
                '<button class="uk-button js-modal-confirm-cancel ">Cancel</button></div>',
            ].join(''),
            options
        );

        modalsavePost.element
            .find('.js-modal-confirm-cancel')
            .on('click', function () {
                oncancel();
            })
            .end()
            .find('.uk-button-success')
            .on('click', function () {
                onInsert();
            });

        modalsavePost.show();

        oncancel = function (e) {
            modalsavePost.hide();
        };

        var onInsert = function (e) {
            $.ajax({
                type: 'POST',
                url:
                    parent.wex.url.baseUrl +
                    '/admin/manage/update/postproperty',
                data: {
                    slug_id: slug_id,
                    postBaseUrl: postBaseUrl,
                    categoryBaseUrl: categoryBaseUrl,
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr(
                        'content'
                    ),
                },
                error: function (err) {
                    var Error = err.responseJSON.errors;

                    $.each(Error, function (type, msg) {
                        modalsavePost.hide();
                        parent.console.pop.warning({
                            text: msg,
                            delay: 5000,
                        });
                    });
                },
                success: function (data) {
                    console.log('data: ', data);
                    modalsavePost.hide();

                    //			    	 alert(data.url);
                    parent.console.pop.success({
                        data,
                        delay: 5000,
                    });

                    if ($('#isType').get(0)) {
                        var isType = $('#isType').val();
                        switch (isType) {
                            case 'Page':
                            case 'System':
                                parent.location.reload();
                                break;

                            default:
                                parent.window.location.replace(
                                    parent.wex.url.WYS_SHOW_URL + '/' + data.url
                                );
                                break;
                        }
                    } else {
                        parent.location.reload();
                    }
                },
            });
        };
    }

    async function saveSiteProperty(data) {
        var url = {};
        url.page = url.post = url.system = 'page';
        url.site = 'site';

        console.log(url[currentTab]);

        var beforeSlug, afterSlug;
        beforeSlug = parent.activeSlug;
        var responseAjax = '';
        var ajaxSaveSiteProperty = await $.ajax({
            type: 'POST',
            url:
                parent.wex.url.baseUrl +
                '/admin/manage/update/' +
                url[currentTab] +
                'property',
            data: data,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            success: function (response) {
                responseAjax = response;
                var strcurrentTab = [currentTab].toString();
                var msgCurrent =
                    strcurrentTab.charAt(0).toUpperCase() +
                    strcurrentTab.slice(1);

                parent.console.pop.success({
                    text: msgCurrent + ' config saved.',
                    delay: 5000,
                });

                disabledSavebtn();
                afterSlug = $('#' + currentTab + 'property')
                    .find('#previewUrlSEO')
                    .val();

                if (currentTab == 'site') {
                    if (response.seo_append) {
                        response.seo_append = response.seo_append.replace(
                            /\/%/g,
                            '%'
                        );
                    }
                    if (response.seo_prepend) {
                        response.seo_prepend = response.seo_prepend.replace(
                            /\/%/g,
                            '%'
                        );
                    }
                    wex.globalSetting.embed_seo_append = response.seo_append;
                    wex.globalSetting.embed_seo_prepend = response.seo_prepend;
                }

                if (currentTab == 'page') {
                    var slug = parseInt(response.data.slug_id);
                    var ptype = { page_onmenu: '', page_internal: '' };
                    $.each(ptype, function (type) {
                        var indexWex = $.map(
                            parent.wex['page'][type],
                            function (obj) {
                                return obj.slug_id;
                            }
                        ).indexOf(slug);

                        if (indexWex != -1) {
                            parent.wex['page'][type][indexWex].slug_name =
                                response.data.slug_name;
                        }
                    });
                }

                setTitleSEO(response.seo_append, response.seo_prepend);
                setTimeout(function () {
                    parent.$('.overlaypanel').remove();
                }, 700);
            },
            error: function (xhr, thrownError) {
                parent.console.pop.error({
                    title: 'Error',
                    text: xhr.responseJSON.message,
                });
            },
        });

        return await responseAjax;
    }

    function BuildSiteConfigTabs() {
        // $('#tab-control').tabs();
        $('.Tabs-type').click(function () {
            currentTab = $(this).attr('cmd-type');
        });

        $('#siteproperty .Pageprop').hide();

        setSitePropertyModal(0);
    }

    function setSitePropertyModal(subActive) {
        var index_active = 0;
        if (currentPageData) {
            if (currentPageData.slug_type == 'System') {
                index_active = 1;
                currentTab = 'system';
            }

            //Check current page
            if (
                currentPageData.slug_type == 'Post' ||
                currentPageData.slug_type == 'Category' ||
                currentPageData.slug.slug_name == 'blog'
            ) {
                index_active = 2;
                currentTab = 'post';
                subActive = subActive + 1;
                if (currentPageData.slug_type == 'System') {
                    subActive = 0;
                }
            }

            if (currentPageData.slug_type == 'Page') {
                index_active = 1;
                currentTab = 'page';
            }
        }

        $('#tab-control').tabs({
            active: index_active,
            activate: function (event, ui) {
                currentTab = ui.newPanel[0].id.replace('-tab', '');
                if (currentTab == 'site') {
                    setInputSitedata();
                } else {
                    activeData = null;
                }
                if (currentId[currentTab]) {
                    setInputdata(currentId[currentTab]);
                }
                //disabledSavebtn();setSelected(); if want to clear data when change tap
            },
        });

        setInputSitedata();
        $('.Pageprop').tabs({
            active: 0,
        });

        $('#' + currentTab + 'property')
            .find('.Pageprop')
            .tabs({
                active: subActive,
            });
        if (parent.wex.page.page_internal.length == 0) {
            $('.listtitle_internal').hide();
        }
    }

    function dataLists() {
        console.log('Function: dataLists');
        var data = parent.wex.page.page_tree;
        var IndexHome = $.map(data, function (index) {
            return index.type;
        }).indexOf('home');
        var IconHome =
            IndexHome >= 0 ? data[IndexHome].statusIcon : 'home-normal';

        // Page
        var p_plugins = ['types', 'search'];
        var list_page_internal = parent.wex.page.page_internal.filter(function (
            value,
            index,
            arr
        ) {
            return value.type != 'blogindex' && value.type != 'post';
        });

        var list_page_onmenu = parent.wex.page.page_tree.filter(function (
            value,
            index,
            arr
        ) {
            return value.type != 'blogindex' && value.type != 'post';
        });

        mapSlugData(list_page_onmenu);

        setJstree(
            $('#page_pageonmenu'),
            'pageonmenu',
            list_page_onmenu,
            {
                ...JStreeTypeIconHome(),
                ...JStreeTypeIconPage(),
                ...JStreeTypeIconSystem(),
            },
            p_plugins,
            true
        );

        //Jstree search page
        var timeout = false;
        $('input[name="page_search"]').keyup(function () {
            var listItem = $(this).val();

            if (timeout) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(function () {
                $('#page_pageonmenu').jstree('search', listItem);
            }, 250);
        });

        // Post
        var b_lists = parent.wex.blog.blog_lists.concat(
            parent.wex.blog.blog_listscategory
        );
        mapSlugData(b_lists);

        var b_plugins = ['types', 'search'];

        setJstree(
            $('#post_lists'),
            'post',
            b_lists,
            {
                ...JStreeTypeIconHome(),
                ...JStreeTypeIconBlog(),
            },
            b_plugins,
            true
        );

        //Jstree search post
        $('input[name="blog_search"]').keyup(function () {
            var listItem = $(this).val();

            if (timeout) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(function () {
                $('#post_lists').jstree('search', listItem);
            }, 250);
        });

        //Site
        var site_menu = parent.wex.sitepage.custom_list;

        setJstree(
            $('#page_siteonmenu'),
            'siteonmenu',
            site_menu,
            {
                ...JStreeTypeIconHome(),
                ...JStreeTypeIconPage(),
                ...JStreeTypeIconBlog(),
                ...JStreeTypeIconSystem(),
            },
            p_plugins,
            true
        );

        $('input[name="site_search"]').keyup(function () {
            var vSystem = $(this).val();
            $('#page_siteonmenu').jstree('search', vSystem);
        });
    }

    //Create JSTree
    function setJstree(
        obj,
        type,
        data,
        types,
        plugins,
        openall,
        callback = null
    ) {
        var selected = {};
        obj.jstree({
            core: { data: data },
            types: types,
            search: {
                case_insensitive: true,
                show_only_matches: true,
            },
            plugins: plugins,
        })
            .bind('loaded.jstree', function (event, data) {
                if (openall) $(this).jstree('open_all');

                if (currentPageData) {
                    setDefaultSelected(obj, type);
                }
                if ($(this).attr('id') == 'system_lists') {
                    const system_lists = $(this);
                    $.each(['module2', 'module3'], function (index, value) {
                        system_lists.jstree().disable_node(value);
                    });
                }
            })
            .on('select_node.jstree', function (e, data) {
                console.log(
                    '%c ============= select_node.jstree ===========',
                    'color:red'
                );

                var isIdDataModule = data.node.id.indexOf('module_');

                switch (isIdDataModule) {
                    case 0:
                        // Module
                        // Tab site

                        var dataSite = {
                            id: data.node.id,
                            package: data.node.li_attr.package,
                        };

                        SetTabsSite(dataSite);

                        break;
                    case -1:
                        // Not Module
                        // Tab page,blog
                        if (data.node.data != 'undefined') {
                            console.log('!undefined');
                            console.log('selected: ', selected);

                            setInputdata(data.node);
                            selected[currentTab] = data.node.id;
                        } else {
                            console.log('undefined');
                            elementSystemBase();
                        }

                        break;
                }

                // }
                //Not allow multiselect
                var countSelected = data.selected.length;
                if (countSelected > 1) {
                    data.instance.deselect_node([data.selected[0]]);
                }
                if (type == 'pageonmenu') {
                    $('#page_pageinternal').jstree('deselect_all');
                }
            });
    }

    function setDefaultSelected(obj, type) {
        if (
            (currentPageData.slug_type == 'Post' ||
                currentPageData.slug_type == 'Category' ||
                currentPageData.slug.slug_name == 'blog') &&
            type == 'post'
        ) {
            currentPageData.slug_type == 'Category'
                ? (defaultId = 'category' + currentPageData.page_id)
                : (defaultId = currentPageData.page_id);
            defaultObj = obj;
            setSelected();
        } else if (
            currentPageData.slug_type == 'Page' &&
            type == 'pageonmenu'
        ) {
            const i = parent.wex.page.page_tree
                .map(function (el) {
                    return el.page_id;
                })
                .indexOf(currentPageData.page_id);
            if (~i) {
                defaultId = parent.wex.page.page_tree[i].id;
                defaultObj = obj;
                setSelected();
            }
        } else if (
            currentPageData.slug_type == 'Page' &&
            type == 'pageinternal'
        ) {
            defaultId = currentPageData.page_id;
            defaultObj = obj;
            setSelected();
        }
    }

    function setSelected() {
        defaultObj.find('li[id=' + defaultId + '] a:first').click();
    }

    // Global Data
    function setInputSitedata() {
        disabledSavebtn();

        $('#editorJsGlobal').val(wex.globalSetting.js);
        $('#editorCssGlobal').val(wex.globalSetting.css);
        $('#editorMetaGlobal').val(wex.globalSetting.meta);

        var append = wex.globalSetting.embed_seo_append;
        var prepend = wex.globalSetting.embed_seo_prepend;
        var seoPrepend = $('#seo-prepend').val();
        var seoAppend = $('#seo-append').val();

        if (
            wex.globalSetting.embed_seo_append == '' ||
            wex.globalSetting.embed_seo_append == null
        ) {
            $("input[name=editorSeoappendGlobal][value='']").prop(
                'checked',
                true
            );
            append = '';
        } else if (wex.globalSetting.embed_seo_append == seoAppend) {
            $(`input[name=editorSeoappendGlobal][value="${seoAppend}"]`).prop(
                'checked',
                true
            );
        } else {
            $('input[name=editorSeoappendGlobal][value=other]').prop(
                'checked',
                true
            );
            $('input[name=appendother]').val(
                wex.globalSetting.embed_seo_append
            );
        }

        $('input[type=radio][name=editorSeoappendGlobal]').change(function () {
            $('input[name=appendother]').val('');
        });

        if (
            wex.globalSetting.embed_seo_prepend == '' ||
            wex.globalSetting.embed_seo_prepend == null
        ) {
            $("input[name=editorSeoprependGlobal][value='']").prop(
                'checked',
                true
            );
            prepend = '';
        } else if (wex.globalSetting.embed_seo_prepend == seoPrepend) {
            $(`input[name=editorSeoprependGlobal][value='${seoPrepend}']`).prop(
                'checked',
                true
            );
        } else {
            $('input[name=editorSeoprependGlobal][value=other]').prop(
                'checked',
                true
            );
            $('input[name=prependother]').val(
                wex.globalSetting.embed_seo_prepend
            );
        }

        $('input[type=radio][name=editorSeoprependGlobal]').change(function () {
            $('input[name=prependother]').val('');
        });

        setTitleSEO(append, prepend);
    }

    function setTitleSEO(append, prepend) {
        $('.previewTitleSEO').css('float', '');
        $('.previewAppendSEO,.previewPrependSEO').remove();

        if (append) {
            $('.previewTitleSEO').css('float', 'left');
            $('.previewTitleSEO').after(
                '<h2 class="previewAppendSEO"  style="float:left;padding-left: 5px; opacity:0.5;">' +
                    append.replace(
                        '%SITE_NAME%',
                        wex.globalSetting.site_brand
                    ) +
                    '</h2>'
            );
        }

        if (prepend) {
            $('.previewTitleSEO').before(
                '<h2 class="previewPrependSEO" style="float:left;padding-right: 5px;" >' +
                    prepend.replace(
                        '%SITE_NAME%',
                        wex.globalSetting.site_brand
                    ) +
                    '</h2>'
            );
        }
    }

    /**
     * @param {Object} dataNode
     */
    //set Data by click on JSTree Lists relative with slug_id
    const setInputdata = dataNode => {
        var dataID = dataNode.id ?? dataNode;
        currentId[currentTab] = dataID;
        disabledSavebtn();

        var title = {};
        title.page = 'page_title';
        title.post = 'post_title';
        title.system = 'system_title';

        var title_obj = title[currentTab];
        var url = `${parent.wex.url.baseUrl}/admin/manage/update/get${currentTab}active`;

        switch (currentTab) {
            case 'page':
                elementPageManage(dataNode);
                break;
            case 'post':
                elementPostManage();
                break;
            default:
                // elementSystemManage();
                break;
        }

        if (currentTab == 'page' && !dataID) {
            elementPageBase();
        } else {
            $(`#${currentTab}_loading`).show();
            $.get(url, { data_id: dataID }, function (data) {
                $('#' + currentTab + '_loading').hide();
                if (data) {
                    activeData = data;
                    $('.' + title_obj).html(activeData.name);
                    $('.' + title_obj).attr('slug-name', activeData.slug_name);
                    getManage();
                    getSEO();
                    getVisibility(data);
                    getLog(data.log);
                } else {
                    if (currentTab == 'system') {
                        elementSystemBase();
                    }
                }
            });
        }
    };

    // show log by click on JSTree Lists relative with slug_id
    function getLog(data) {
        if ($.fn.DataTable.isDataTable('#' + currentTab + '-log')) {
            $('#' + currentTab + '-log')
                .DataTable()
                .destroy();
        }

        $('#' + currentTab + '-log tbody').empty();
        $('#' + currentTab + '-log').DataTable({
            data: data,
            order: [[0, 'desc']],
            columns: [
                { data: 'updated_at' },
                { data: 'username' },
                { data: 'email' },
                { data: 'action' },
            ],
        });
    }

    // Put data CSS ,JS ,Meta
    function getManage() {
        var obj = $('#' + currentTab + '-tab');
        console.log(obj);

        if (!obj.find('.err_editorCssCustom').hasClass('uk-hidden')) {
            obj.find('.err_editorCssCustom').addClass('uk-hidden');
        }
        if (!obj.find('.err_editorJSCustom').hasClass('uk-hidden')) {
            obj.find('.err_editorJSCustom').addClass('uk-hidden');
        }

        obj.find('#editorJsCustom').val(activeData.js);
        obj.find('#editorCssCustom').val(activeData.css);
        obj.find('#editorMetaCustom').val(activeData.metatag);
    }

    function getVisibility(data) {
        var customVis = $('#' + currentTab + '-tab').find('#custom-visibility');
        var autoVis = $('#' + currentTab + '-tab').find('#auto-visibility');
        var disable = activeAuto ? 'disable' : '';

        evenDataVisibility(data);

        autoVis.attr('aria-expanded', activeAuto);
        customVis.attr('aria-expanded', !activeAuto);
        //	      console.log(customVis);

        if (!activeAuto) {
            disabledSavebtn();
            autoVis.removeClass('uk-active');
            customVis.addClass('uk-active');
            autoVis.closest('ul').removeClass('seo-bgoff');
        } else {
            disabledSavebtn();
            autoVis.addClass('uk-active');
            customVis.removeClass('uk-active');
            customVis.closest('ul').addClass('seo-bgoff');
        }
    }

    // Put SEO
    function getSEO() {
        var urlSEO = $('#' + currentTab + '-tab').find('#previewUrlSEO');
        var urlPrefix = $('#' + currentTab + '-tab').find('#prefixSlug');
        var textUrlSEO = $('#' + currentTab + '-tab').find('#textUrlSEO');

        var titleSEO = $('#' + currentTab + '-tab').find('#previewTitleSEO');
        var desSEO = $('#' + currentTab + '-tab').find('#previewDesSEO');

        console.log('================= Current Tab ===================');
        console.log(currentTab);
        console.log('activeData: ', activeData);
        console.log('====================================');

        var autoButton = $('#' + currentTab + '-tab').find('#auto-seo');
        var customButton = $('#' + currentTab + '-tab').find('#custom-seo');

        var focusKeyword = $('#' + currentTab + '-tab').find('#focuskeyword');
        //When auto SEO
        var eventAutoSEO = function () {
            console.log('Function: ', eventAutoSEO);
            desSEO.removeAttr('contenteditable');
            desSEO.removeClass('siteproperty-active');
            titleSEO.removeAttr('contenteditable');
            titleSEO.removeClass('siteproperty-active');
            urlSEO.prop('disabled', true);
            urlSEO.hide();
            textUrlSEO.show();

            urlSEO.val(activeData.slug_name);
            if (activeData.slug_id == parent.currentSlugID) {
                generateSEO();
            } else {
                axiosGetSeoData({ slug_id: activeData.slug_id }).then(
                    result => {
                        findContentSeo(result);
                    }
                );
            }
            titleSEO.text(activeData.seo.titleAuto);
            desSEO.text(activeData.seo.descriptionAuto);
            autoButton
                .removeClass('uk-active')
                .attr('aria-expanded', 'true')
                .addClass('uk-active');
            customButton
                .removeClass('uk-active')
                .attr('aria-expanded', 'false');
            $('#' + currentTab + '-tab')
                .find('.rvsb-switch')
                .removeClass('seo-bgopen');
            $('#' + currentTab + '-tab')
                .find('.rv-seo')
                .removeClass('rv-seo-custom');
        };
        //When custom SEO
        var eventCustomSEO = function () {
            titleSEO.attr('contenteditable', 'true');
            titleSEO.addClass('siteproperty-active');
            desSEO.attr('contenteditable', 'true');
            desSEO.addClass('siteproperty-active');
            if (currentTab !== 'system') {
                urlSEO.prop('disabled', false);
                urlSEO.show();
                textUrlSEO.hide();
                urlSEO.prop('disabled', false);
            }

            customButton
                .removeClass('uk-active')
                .attr('aria-expanded', 'true')
                .addClass('uk-active');
            autoButton.removeClass('uk-active').attr('aria-expanded', 'false');
            $('#' + currentTab + '-tab')
                .find('.rvsb-switch')
                .addClass('seo-bgopen');
            $(`#${currentTab}-tab`).find('.rv-seo').addClass('rv-seo-custom');

            var title =
                dataCustomSeo['title'] == undefined
                    ? activeData.seo.titleAuto
                    : dataCustomSeo['title'];

            var url =
                dataCustomSeo['url'] == undefined
                    ? activeData.slug_name
                    : dataCustomSeo['url'];
            var description =
                dataCustomSeo['description'] == undefined
                    ? activeData.seo.descriptionAuto
                    : dataCustomSeo['description'];

            titleSEO.text(title);
            urlSEO.val(url);
            desSEO.text(description);
        };

        urlSEO.val(activeData.slug_name);
        var slug_prefix = '';
        if (activeData.slug_prefix) {
            slug_prefix = activeData.slug_prefix + '/';
        }
        urlPrefix.text(parent.wex.url.baseUrl + '/' + slug_prefix);
        textUrlSEO.text(activeData.slug_name);

        if (activeData.seo.useType == 1) {
            eventAutoSEO();
        } else {
            eventCustomSEO();
            titleSEO.text(activeData.seo.titleCustom);
            desSEO.text(activeData.seo.descriptionCustom);
        }

        autoButton.click(function () {
            showSavebtn();
            eventAutoSEO();
        });

        customButton.click(function () {
            showSavebtn();
            eventCustomSEO();
        });

        focusKeyword.unbind('keyup').keyup(function () {
            var focusData = '<b class="rep">' + $(this).val() + '</b>';
            var descriptionText = $(this).val();
            var regex2 = new RegExp(descriptionText, 'img');
            $('.rep').each(function () {
                $(this).replaceWith($(this).text());
            });
            var data = desSEO.html();

            setTimeout(function () {
                desSEO.html(data.replace(regex2, focusData));
            }, 50);
        });

        urlSEO.unbind('focusin').focusin(function () {
            urlSEO.unbind('blur').blur(function () {
                var urlVal = $(this).val().trim();
                if (urlVal === '') {
                    $(this).val(activeData.slug_name);
                }

                if (activeData.slug_name != $(this).val().trim()) {
                    checkSlug(urlVal, function (returnValue) {
                        var ajaxSlug = returnValue;
                        urlSEO.val(ajaxSlug);
                    });
                }
            });
        });
    }

    function checkSlug(slug, returnVal) {
        $.ajax({
            type: 'POST',
            url: parent.wex.url.baseUrl + '/admin/wysiwyg/service/checkSlug',
            data: {
                slug: slug.trim(),
                _token: $('meta[name="csrf-token"]').attr('content'),
            },
            success: returnVal,
        });
    }

    function generateSEO() {
        var fb = parent.$('#frameBody').get(0).contentWindow;
        var title = fb
            .$('#selected_headerbanner')
            .find('h1, h2, h3, h4, h5, h6 , p')
            .first()
            .text();
        if (!title.trim()) {
            title = activeData.name;
        }

        var description = fb
            .$('#selected_body')
            .find('p')
            .filter(function () {
                return $(this).text().length > 5;
            })
            .first()
            .text();

        if (fb.$('#selected_body').find('p')[0].firstElementChild) {
            description = fb.$('#selected_body').find('p')[0 + 1].innerText;
        }

        if (!description.trim()) {
            description = fb
                .$('.sidebar-left , .sidebar-right')
                .filter(function () {
                    return $(this).css('display') == 'block';
                })
                .find('p')
                .filter(function () {
                    return $(this).text().length > 5;
                })
                .first()
                .text();
        }
        var seo = {
            title: title,
            description: description,
        };

        var titleSEO = $('#' + currentTab + '-tab').find('#previewTitleSEO');
        var desSEO = $('#' + currentTab + '-tab').find('#previewDesSEO');
        titleSEO.text(seo.title);
        desSEO.text(seo.description);
    }

    function findContentSeo(objSeo) {
        var header = $(objSeo.headerContent).find('#selected_headerbanner');
        var title = header.find('h1, h2, h3, h4, h5, h6 , p').first().text();
        var frameBody = parent.$('#frameBody').get(0).contentWindow;

        // if find in header null use page name
        if (!title.trim()) {
            title = objSeo.pageName;
        }

        var description =
            frameBody.$('#selected_body').find('p')[0].firstElementChild
                ?.nodeName == 'IMG'
                ? frameBody.$('#selected_body').find('p')[0 + 1].innerText
                : frameBody.$('#selected_body').find('p')[0].innerText;

        var seo = {
            title: title,
            description: description,
        };
        var titleSEO = $(`#${currentTab}-tab`).find('#previewTitleSEO');
        var desSEO = $(`#${currentTab}-tab`).find('#previewDesSEO');
        titleSEO.text(seo.title);
        desSEO.text(seo.description);
    }

    // === Manage View ===
    function showSavebtn() {
        $('#' + currentTab + 'property')
            .find('.saveproperty')
            .removeAttr('disabled');
    }

    function disabledSavebtn() {
        $('#' + currentTab + 'property')
            .find('.saveproperty')
            .prop('disabled', true);
    }

    function elementPostBase() {
        /// default post
        $('#post-content').tabs({ active: 0 });
        $('#post_lists').jstree('deselect_all');
        $('.post-manange').addClass('uk-hidden');
        $('.post-base').removeClass('uk-hidden');
        $('.post_title').html('');

        if ($('#custom-postBaseUrl').attr('cmd-custom') != 'false') {
            $('#custom-postBaseUrl').prop('checked', true);
            $('.ui-postdisabled').removeAttr('disabled');
        }

        if ($('#custom-categoryBaseUrl').attr('cmd-custom') != 'false') {
            $('#custom-categoryBaseUrl').prop('checked', true);
            $('.ui-catedisabled').removeAttr('disabled');
        }

        activeData = null;
        currentId[currentTab] = '';

        $('.radiopostBaseUrl').change(function () {
            $('.ui-postdisabled').attr('disabled', 'disabled');
        });

        $('.custom-postBaseUrl').change(function () {
            $('.ui-postdisabled').removeAttr('disabled');
        });

        $('.radiocategoryBaseUrl').change(function () {
            $('.ui-catedisabled').attr('disabled', 'disabled');
        });

        $('.custom-categoryBaseUrl').change(function () {
            $('.ui-catedisabled').removeAttr('disabled');
        });

        console.log('FN::elementPostBase');
    }

    function elementPostManage() {
        $('#post-content').tabs({ active: 1 });
        $('.post-base').addClass('uk-hidden');
        $('.post-manange').removeClass('uk-hidden');

        //      $('.tab-qrcode').addClass("uk-hidden");
        console.log('FN::elementPostManage');
    }

    function elementPageBase() {
        /// default page
        $('#page-content').addClass('uk-hidden');
        $('#page_pageinternal, #page_pageonmenu').jstree('deselect_all');
        $('.page_title').html('Please, Select page for manage information.');
        activeData = null;
        currentId[currentTab] = '';
        console.log('FN::elementPageBase');
    }

    /**
     * @param {object} dataNode
     */
    function elementPageManage(dataNode) {
        console.log('FN::elementPageManage');

        //modalPageproperty.find('#page-base').addClass("uk-hidden");
        $('#page-content').tabs({ active: 0 });
        $('#page-content').removeClass('uk-hidden');
        $('.tab-qrcode').removeClass('uk-hidden');

        // New Feature 7.4
        var isCheckType = dataNode.type;
        var isNoteSystem = isCheckType != 'system';
        $('[href="#visibility-option-page"]')
            .closest('li')
            .toggle(isNoteSystem);
    }

    function elementSystemBase() {
        /// default page
        $('#system-content').addClass('uk-hidden');
        $('#system_lists').jstree('deselect_all');
        $('.system_title').html('Please, Select page for manage information.');
        activeData = null;
        currentId[currentTab] = '';
        console.log('FN::elementSystemBase');
    }

    function elementSystemManage() {
        $('#system-content').tabs({ active: 0 });
        $('#system-content').removeClass('uk-hidden');
        console.log('FN::elementSystemManage');
    }
    // === Manage View ===

    function evenDataVisibility(data) {
        console.log('FN::evenDataVisibility');

        var valRadio = data.visibility;
        var checkedRole = data.ChildRestricted;
        $('.role').prop('checked', false);

        activeAuto = valRadio != '0' ? false : true;
        $('.visibility').attr('disabled', false);
        $('.visibility[value=' + valRadio + ']').trigger('click');
        $('.visibility').attr('disabled', activeAuto);
        $('.Visibility_onoff').prop('checked', !activeAuto);

        if (checkedRole != null && valRadio == '2') {
            $('.role_val[value=3]').prop('checked', false);

            $.each(checkedRole, function (k, v) {
                $('.role_val[value=' + v + ']').prop('checked', true);
            });
        } else {
            $('.role_val').prop('checked', false);
        }
    }

    function EventVisibility() {
        $('.visibility').click(function () {
            var isRes = $(this).val() == 2 ? true : false;

            $('.radioVRestricted').toggle(isRes);

            if (!isRes) {
                $('.role_val').prop('checked', isRes);
            }

            $('.role_val[value=3]').prop('checked', isRes);
        });

        /*   $('.custom-visibility').click(function(e){
          console.log($('.visibility'));

	    	  $('.visibility').attr('disabled', false);
	    	  $(this).closest('ul').removeClass('seo-bgoff');
	    	  showSavebtn();

	      });

	      $('.auto-visibility').click(function(e){
          console.log($('.visibility'));

	    	  $('.visibility[value=0]').trigger('click');
	    	  $('.visibility').attr('disabled', true);
	    	  $(this).closest('ul').addClass('seo-bgoff');
	    	  showSavebtn();

        });  */

        $('.Visibility_onoff').click(function (param) {
            if (this.checked) {
                $('.visibility').attr('disabled', false);
                $(this).closest('ul').removeClass('seo-bgoff');
            } else {
                $('.visibility[value=0]').trigger('click');
                $('.visibility').attr('disabled', true);
                $(this).closest('ul').addClass('seo-bgoff');
            }

            showSavebtn();
        });
    }

    function SetTabsSite(data) {
        var ClassTab = data.id;
        var isIdTabs = $('#siteproperty .Pageprop li a.' + ClassTab)
            .first()
            .attr('href');
        var idTabs = id2Index('#siteproperty .Pageprop', isIdTabs);

        if (idTabs != '0') {
            $('#savemoduleProperty').show();
            $('#saveSiteProperty').hide();
        } else {
            $('#savemoduleProperty').hide();
            $('#saveSiteProperty').show();
        }

        $('#siteproperty .Pageprop').show();
        $('#siteproperty .Pageprop li a:not(.' + ClassTab + ')')
            .closest('li')
            .hide();
        $('#siteproperty .Pageprop li a.' + ClassTab)
            .closest('li')
            .show();

        var modulename = ClassTab.match(/module\_(.*)/);

        // moduleActive = modulename[1];

        moduleActive = ClassTab;
        packagename = data.package;

        $('#siteproperty .Pageprop').tabs({
            active: idTabs,
        });
    }

    function id2Index(tabsId, srcId) {
        var index = -1;
        var i = 0,
            tbH = $(tabsId).find('li a');
        var lntb = tbH.length;
        if (lntb > 0) {
            for (i = 0; i < lntb; i++) {
                var o = tbH[i];

                if (o.href.search(srcId) > 0) {
                    index = i;
                }
            }
        }
        return index;
    }

    function mapSlugData(list) {
        console.log('================ mapSlugData ====================');
        console.log(list);
        console.log('====================================');
        list.map(data => {
            if (data.slug_name) {
                data['li_attr'] = {
                    'slug-name': data.slug_name,
                    'slug-id': data.slug_id,
                    'slug-prefix': data.slug_prefix,
                };
            }
        });
    }

    function modalRefreshAfterSave(data) {
        var UI = parent.UIkit;

        var options = {
            bgclose: false,
            keyboard: false,
            modal: false,
        };

        var modalsave = UI.modal.dialog(
            [
                '<div class="uk-margin uk-modal-header"><h2>Save & Refresh</h2></div>',
                '<div class="uk-margin uk-modal-content">Do you want to save changes? It will automatically refresh this page.</div>',
                '<div class="uk-modal-footer uk-text-left clear"><br><button class="uk-button uk-button-success  js-modal-confirm">Ok</button>',
                '<button class="uk-button js-modal-confirm-cancel ">Cancel</button></div>',
            ].join(''),
            options
        );

        modalsave.element
            .find('.js-modal-confirm-cancel')
            .on('click', function () {
                oncancel();
            })
            .end()
            .find('.uk-button-success')
            .on('click', function () {
                onInsert();
            });

        modalsave.show();

        oncancel = function (e) {
            modalsave.hide();
        };

        var onInsert = function (e) {
            var aftersave = saveSiteProperty(data);

            aftersave.then(function (data) {
                console.log('data: ', data);
                var status = data.status;
                var slugCurrent = data.data.slug_id;
                var fb = parent.$('#frameBody').get(0)?.contentWindow;
                var slugCurrentURL = parent
                    .$('.current-optionPage')
                    .attr('slug-id');
                var dataNewUrl = data.data.url.replace(
                    parent.wex.url.baseUrl,
                    ''
                );

                var getUrl = parent.window.location.href;

                if (status) {
                    if (slugCurrent == slugCurrentURL) {
                        var newURL = `${parent.wex.url.WYS_SHOW_URL}${dataNewUrl}`;
                        console.log('newURL: ', newURL);

                        parent.window.history.pushState(
                            'data',
                            'Title',
                            newURL
                        );
                    } else {
                        var matchUrlCurrent = getUrl.match(
                            activeData.slug_name
                        );
                        var oldURL = getUrl.replace(
                            parent.wex.url.WYS_SHOW_URL,
                            ''
                        );

                        if (matchUrlCurrent) {
                            var replaceNewURL = oldURL.replace(
                                activeData.slug_name,
                                data.data.slug_name
                            );

                            var newURL = `${parent.wex.url.WYS_SHOW_URL}${replaceNewURL}`;

                            parent.window.history.pushState(
                                'data',
                                'Title',
                                newURL
                            );
                        }
                    }
                    parent.location.reload();
                }

                modalsave.hide();
            });
        };
    }
});
